export default __webpack_public_path__ + "static/media/profile_male@2x.92f79dfa.png";